import React, { useState } from 'react';
import axios from "axios";
import { Card, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFilePdf,
  faMinusSquare, faPlusSquare
} from '@fortawesome/free-solid-svg-icons';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import { PhotoDocumentModal, PhotoDocumentEditModal, PhotoDocumentRemovalModal } from './Modals';
import LoadingLink from '../components/LoadingLink';
import ActionsDropdown from '../components/ActionsDropdown';
import { isImageFile, getFileNameFromUrl } from '../utils/files';

function PhotoDocuments(props) {

  const [images, setImages] = useState([]);
  const [showAddPhoto, setShowAddPhoto] = useState(false);
  const handleCloseAddPhoto = () => setShowAddPhoto(false);
  const [photoToRemove, setPhotoToRemove] = useState({id: '', name:'', url:''});
  const [showRemovePhoto, setShowRemovePhoto] = useState(false);
  const handleCloseRemovePhoto = () => setShowRemovePhoto(false);
  const [photoToEdit, setPhotoToEdit] = useState({id: '', name:'', url:''});
  const [showEditPhoto, setShowEditPhoto] = useState(false);
  const handleCloseEditPhoto = () => setShowEditPhoto(false);

  // Handle remove photo.
  const handleSubmitRemovePhoto = async () => {
    await axios.patch(props.url, {'remove_image':photoToRemove.id})
    .then(response => {
      props.setData(prevState => ({ ...prevState, "images":props.data.images.filter(image => image.id !== photoToRemove.id)}));
      handleCloseRemovePhoto()
    })
    .catch(error => {
    });
  }

  return (
    <>
    <div className="row mt-3">
      <div className="col-12 d-flex">
        <Card className="border rounded" style={{width:"100%"}}>
          <Card.Body style={{marginTop:"-10px"}}>
            <div className="d-flex justify-content-between" style={{marginBottom:"-10px"}}>
              <h4 style={{paddingTop:"5px"}}>Photo Documents</h4>
              {props.isLoading ? (
                <Spinner
                  className="align-self-center me-3"
                  {...{
                    as: 'span',
                    animation: 'border',
                    size: undefined,
                    role: 'status',
                    'aria-hidden': 'true',
                    variant: 'light',
                    style: {
                      height: '1.5rem',
                      width: '1.5rem',
                      marginBottom: '0.75rem'
                    }
                  }}
                />
              ) : (
                <ActionsDropdown variant="secondary" title="Actions">
                  <LoadingLink
                    onClick={() => setShowAddPhoto(true)}
                    isLoading={props.isLoading}
                    className="d-block"
                    label={"Add Photo Document to " + props.object}
                  >
                    <FontAwesomeIcon icon={faPlusSquare} inverse />
                  </LoadingLink>
                </ActionsDropdown>
              )}
            </div>
            <p className="phr" />
            <span className="d-flex flex-wrap align-items-end" style={{marginLeft:"-15px"}}>
            {props.data.images.map((image, index) => (
              <span key={index} className="ms-3 mb-3">
                <Card
                  className="border rounded animal-hover-div"
                  style={{
                    width:"153px",
                    whiteSpace:"nowrap",
                    overflow:"hidden",
                    textAlign: "center"
                  }}
                >
                  <a href={image.url} target="_blank" rel="noreferrer" className="animal-link" style={{textDecoration:"none", color:"white"}}>
                    {isImageFile(image.url) ? (
                      <Card.Img
                        className="border-bottom animal-hover-div"
                        variant="top"
                        src={image.url || "/static/images/image-not-found.png"}
                        style={{
                          width: "153px",
                          height: "153px",
                          objectFit: "cover",
                          overflow: "hidden",
                        }}
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon={faFilePdf}
                        size="10x"
                        style={{ height: "153px" }}
                      />
                    )}
                  </a>
                  <Card.Text className="mb-0 text-left">
                    <span
                      title={image.name||getFileNameFromUrl(image.url)}
                      className="ms-1"
                      style={{display:"inline-block", width:"111px", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis", marginBottom:"-5px"}}
                    >
                      {image.name||getFileNameFromUrl(image.url)}
                    </span>
                    <OverlayTrigger
                      key={"edit-photo"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-edit-photo`}>
                          Edit photo document name
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faPencil} className="me-1" inverse onClick={() => {setPhotoToEdit(image); setShowEditPhoto(true);}} title="Edit photo document name" style={{cursor:'pointer'}} />
                    </OverlayTrigger>
                    <OverlayTrigger
                      key={"remove-photo"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-remove-photo`}>
                          Remove photo document
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faMinusSquare} className="me-1" inverse onClick={() => {setPhotoToRemove(image); setShowRemovePhoto(true);}} title="Remove photo document" style={{backgroundColor:"red", cursor:'pointer'}} />
                    </OverlayTrigger>
                  </Card.Text>
                </Card>
              </span>
            ))}
            </span>
            {props.data.images.length < 1 ? <div><span style={{textTransform:"capitalize"}}>{props.object}</span> does not have any photo documents.</div> : ""}
          </Card.Body>
        </Card>
      </div>
    </div>
    <PhotoDocumentModal images={images} url={props.url} setImages={setImages} setData={props.setData} show={showAddPhoto} handleClose={handleCloseAddPhoto} />
    <PhotoDocumentRemovalModal image={photoToRemove} show={showRemovePhoto} handleClose={handleCloseRemovePhoto} handleSubmit={handleSubmitRemovePhoto} />
    <PhotoDocumentEditModal image={photoToEdit} setData={props.setData} url={props.url} show={showEditPhoto} handleClose={handleCloseEditPhoto} />
    </>
  );
};

export default PhotoDocuments;
